import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { TextField, Button, Paper, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {API_URL,API_UPLOAD_URL} from './config';

function decodeJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}
/**Test changes */
const ROLE_OPTIONS = [
  { value: 'Student', label: 'Student' },
  { value: 'Teacher', label: 'Teacher' },
  { value: 'HOD', label: 'HOD' },
  { value: 'Staff', label: 'Staff' },
  { value: 'Admin', label: 'Admin' },
  // add others you actually support server-side (e.g., 'cr', 'HostelStudent', etc.)
];

const CreateUser = () => {
  const navigate = useNavigate();

  const [loginCampusCode, setLoginCampusCode] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Student'); // default
  const [message, setMessage] = useState('');
  const [isAuthorized, setIsAuthorized] = useState(false);

  const token = useMemo(() => localStorage.getItem('auth'), []);

  useEffect(() => {
    if (!token) return;
    const payload = decodeJwtPayload(token);
    if (payload?.campusCode) setLoginCampusCode(payload.campusCode);

    // is admin?
    const roles = (payload?.roles || (payload?.role ? [payload.role] : []))
      .map(r => String(r));
    setIsAuthorized(roles.includes('Admin'));
  }, [token]);

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const handleCreateUser = async () => {
    setMessage('');
    if (!username.trim()) {
      setMessage('Error: Username is required.');
      return;
    }
    if (password.length < 8) {
      setMessage('Error: Password must be at least 8 characters long.');
      return;
    }
    if (!loginCampusCode) {
      setMessage('Error: Your campus code could not be determined from the token.');
      return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/api/auth/create-user`,
        {
          campusCode: loginCampusCode,   // ✅ lowercase key matches backend
          username,
          password,
          role,                          // legacy single role for now
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage(res.data?.message || 'User created successfully.');
      // Optional: clear fields
      setUsername('');
      setPassword('');
      setRole('Student');
    } catch (err) {
      const apiMsg =
        err.response?.data?.message ||
        (typeof err.response?.data === 'string' ? err.response.data : null);
      setMessage('Error creating user: ' + (apiMsg || err.message || 'Unknown error'));
    }
  };

  if (!isAuthorized) {
    return <p style={{ textAlign: 'center', marginTop: 20 }}>Access Denied: Admins only.</p>;
  }

  return (
    <div style={{ padding: 0 }}>
      <Paper
        elevation={5}
        style={{
          backgroundColor: '#F2F2F2',
          padding: 20,
          borderRadius: 10,
          alignItems: 'center',
          maxWidth: 400,
          margin: '20px auto',
        }}
      >
        <h3>Create User</h3>

        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          helperText="Minimum 8 characters"
        />

        <TextField
          select
          label="Role"
          variant="outlined"
          fullWidth
          margin="normal"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          {ROLE_OPTIONS.map(r => (
            <MenuItem key={r.value} value={r.value}>
              {r.label}
            </MenuItem>
          ))}
        </TextField>

        <Button variant="contained" color="primary" onClick={handleCreateUser} fullWidth>
          Create User
        </Button>

        {message && (
          <p style={{ marginTop: 10, color: message.startsWith('Error') ? 'red' : 'green' }}>
            {message}
          </p>
        )}
      </Paper>
    </div>
  );
};

export default CreateUser;
